import {createSelector} from 'reselect';

import {NUMBER_RANGE_REDUCER_STATE_ID} from './number_range_constants';
import {NumberRangeMap} from './number_range_types';
import {RootState} from 'src/js/store';

const getNumberRangeMap = (state: RootState): NumberRangeMap =>
  state[NUMBER_RANGE_REDUCER_STATE_ID]?.numberRangeMap;

const getNumberRangeForFilter = (
  state: RootState,
  numberRangeFilterName: string
): string => numberRangeFilterName;

export const getNumberRange = createSelector(
  [getNumberRangeMap, getNumberRangeForFilter],
  (numberRangeMap, numberRangeFilterName) =>
    numberRangeMap[numberRangeFilterName]
);
